import { CloseOutlined, InboxOutlined } from '@ant-design/icons';
import { Checkbox, Form, Input, message, Select, Upload } from 'antd';
import './PromptGenerator.css';

const noImagesOptions = [
  { value: 1, label: '1 Variant' },
  { value: 2, label: '2 Variants' },
  { value: 3, label: '3 Variants' },
  { value: 4, label: '4 Variants' },
];

const aspectRatioOptions = [
  { value: "21:9", label: "21:9 — Ultra-wide" },
  { value: "16:9", label: "16:9 — Widescreen" },
  { value: "4:3", label: "4:3 — Classic" },
  { value: "3:4", label: "3:4 — Portrait photo" },
  { value: "3:2", label: "3:2 — Photo" },
  { value: "1:1", label: "1:1 — Square" },
];

const PromptGenerator = ({ fileList, setFileList, form }) => {
  const [messageApi, contextHolder] = message.useMessage();

  const uploadProps = {
    multiple: true,
    accept: "image/*",
    fileList,
    showUploadList: false,
    beforeUpload: (file) => {
      if (!file.type?.startsWith("image/")) {
        messageApi.error("Only images are allowed.");
        return Upload.LIST_IGNORE;
      }
      if (fileList.length >= 3) {
        messageApi.warning("You can upload up to 3 images only.");
        return Upload.LIST_IGNORE;
      }
      return false; // no auto upload
    },
    onChange: ({ fileList: newList }) => {
      const limited = newList.slice(0, 3).map((f) => {
        if (!f.thumbUrl && f.originFileObj) {
          f.thumbUrl = URL.createObjectURL(f.originFileObj);
        }
        return f;
      });
      setFileList(limited);
    },
  };

  const handleRemoveFile = (e, uid) => {
    e.stopPropagation();
    setFileList((prev) => prev.filter((x) => x.uid !== uid));
  };

  const draggerPlaceholder = (
    <>
      <p className="ant-upload-drag-icon"><InboxOutlined /></p>
      <p className="ant-upload-text">Click or drag image(s) to upload reference image</p>
      <p className="ant-upload-hint">Upload examples, parts, or inspiration image</p>
    </>
  );

  const draggerPreviews = (
    <div className="dragger-img-container">
      {fileList.map((f) => (
        <div key={f.uid} className="dragger-img" style={{ position: "relative" }}>
          <img
            src={f.thumbUrl}
            alt=""
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
          <button
            type="button"
            aria-label={`Remove ${f.name}`}
            className="icon-btn"
            onClick={(e) => handleRemoveFile(e, f.uid)}
          >
            <CloseOutlined style={{ fontSize: 12 }} />
          </button>
        </div>
      ))}
    </div>
  );

  return (
    <div className="prompt-generator-container">
      {contextHolder}
      <div className="prompt-input-card">
        <div className="prompt-input-description-container">
          <label>Description</label>

          <Form.Item
            name="description"
            rules={[{ required: true, message: "Please input the description." }]}
            style={{ marginBottom: 0 }}
          >
            <Input.TextArea
              placeholder="Example: Create a luxury car interior with red leather seats..."
              autoSize={{ minRows: 3, maxRows: 5 }}
            />
          </Form.Item>
        </div>

        <div>
          <label>Reference Image (optional)</label>
          <div className="dragger">
            <Upload.Dragger {...uploadProps}>
              {fileList.length === 0 ? draggerPlaceholder : draggerPreviews}
            </Upload.Dragger>
          </div>
        </div>
      </div>

      <div className="image-settings-container">
        <label>Image Settings</label>

        <div className="settings-container">
          <div>
            <div>Number of Images</div>
            <Form.Item
              name="num_images"
              style={{ marginBottom: 0 }}
            >
              <Select className="options" options={noImagesOptions} />
            </Form.Item>
          </div>

          <div>
            <div>Aspect Ratio</div>
            <Form.Item
              name="aspect_ratio"
              style={{ marginBottom: 0 }}
            >
              <Select className="options" options={aspectRatioOptions} />
            </Form.Item>
          </div>

          <Form.Item name="apply_brand_guidelines" valuePropName="checked">
            <Checkbox>Apply Brand Guidelines</Checkbox>
          </Form.Item>

          {/* <Form.Item
            name="apply_brand_guidelines"
            valuePropName="checked"
            initialValue={true}
            style={{ marginBottom: 0 }}
          >
            <Checkbox>Apply Brand Guidelines</Checkbox>
          </Form.Item> */}
        </div>
      </div>
    </div>
  );
};

export default PromptGenerator;
